import { render, staticRenderFns } from "./ResourceRoom.vue?vue&type=template&id=e870f288&scoped=true&"
import script from "./ResourceRoom.vue?vue&type=script&lang=js&"
export * from "./ResourceRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e870f288",
  null
  
)

export default component.exports